export default "__VITE_ASSET__DI2Of3OV__"